<template>
  <div>
    <Backdrop v-model="value" :zIndex="1000"></Backdrop>
    <div class="service-popup" v-show="value" :style="{zIndex: 1001}">
      <i class="icon-close" @click="$emit('input', false)"></i>
      <ul class="tab clearfix">
        <li
          class="tab-item"
          v-for="(item, index) in menu"
          :key="index"
          :class="{'tab-item--active': activeIndex===index}"
          @click="activeIndex=index"
        >
          <span class="tab-item__text" v-text="item.text"></span>
        </li>
      </ul>

      <div class="view" v-show="activeIndex==0">
        <img v-lazy="'//s1.huishoubao.com/static/pc/1001/img/process.png'">
      </div>

      <Collapse class="view" accordion v-show="activeIndex==1">
        <CollapseItem name="1-1">
          <p slot="title">Q1: 需要把电池，发票，充电器都邮寄过来吗？</p>
          <div>A1: 如果不是全新手机，只要您寄个裸机（包含电池）即可。</div>
        </CollapseItem>
        <CollapseItem name="1-2">
          <p slot="title">Q2: 快递费用谁出？</p>
          <div>A2: 建议您选择顺丰到付，由我们来出承担运费，22元封顶。</div>
        </CollapseItem>
        <CollapseItem name="1-3">
          <p slot="title">Q3：我已经付了快递费，怎么办？</p>
          <div>A3: 没关系，我们核实之后，后期会补打给您，您查看到包裹签收后可以来电告知下我们，我们会帮您登记。</div>
        </CollapseItem>
        <CollapseItem name="1-4">
          <p slot="title">Q4: 我有多部手机，快递费用怎么算？</p>
          <div>A4: 多部手机用一个包裹邮寄过来，可直接选择到付运费我们承担。</div>
        </CollapseItem>
        <CollapseItem name="1-5">
          <p slot="title">Q5: 保价费用你们承担吗？是否需要购买？</p>
          <div>A5: 我们不承担保价费，需不需要购买看您个人意愿，如果您购买了建议您先垫付运费，后期我们会补打给您。</div>
        </CollapseItem>
        <CollapseItem name="1-6">
          <p slot="title">Q6：快递费用超出了22元你们会怎么办？</p>
          <div>A6: 如果快递费用超出22元，我们会在您手机款里扣除超出的那部分。如：快递费用是23元，我们就直接在您手机款里扣1元。</div>
        </CollapseItem>
        <CollapseItem name="1-7">
          <p slot="title">Q7：一定要发顺丰快递吗？</p>
          <div>A7: 不是的，只是建议使用顺丰到付，其他快递公司也可以的。其他快递需要您先垫付快递费，后期会补打给您的。</div>
        </CollapseItem>
        <CollapseItem name="1-8">
          <p slot="title">Q8：邮寄过来大概要几天时间？</p>
          <div>A8: 不同的地区时间会有不同，一般省外1-3天，国内除偏远地区一般4-5天。您也可以查询顺丰官网的运输时效。</div>
        </CollapseItem>
        <CollapseItem name="1-9">
          <p slot="title">Q9：我刚邮寄了包裹，但忘记把小纸条写上了，而且物流单上的手机号码与下单的手机号码不一致。怎么办？</p>
          <div>A9: 没关系，若查询到您的包裹已签收，您可以来电把您的物流单号与下单的手机号码告诉我们去匹配。</div>
        </CollapseItem>
      </Collapse>

      <Collapse class="view" accordion v-show="activeIndex==2">
        <CollapseItem name="2-1">
          <p slot="title">Q1: 在网上预估的价格和你们实际检测的价格出入大吗？</p>
          <div>A1: 如果您是按照手机实际情况进行评估，那么价格不会有很大出入，但我们要收到您的手机后进行检测，以您手机的实际情况为准。</div>
        </CollapseItem>
        <CollapseItem name="2-2">
          <p slot="title">Q2: 价格不满意会退回手机吗，邮费谁出？</p>
          <div>A2: 如果您对回收价格不满意，可以要求退回，退回费用由我们公司承担。</div>
        </CollapseItem>
        <CollapseItem name="2-3">
          <p slot="title">Q3：支付方式是什么？</p>
          <div>A3: 目前提供微信、银行卡转账和支付宝转账两种交易方式，银行卡暂不支持信用卡</div>
        </CollapseItem>
        <CollapseItem name="2-4">
          <p slot="title">Q4: 多久收到钱?</p>
          <div>A4: 回收宝承诺，收到手机后24小时内进行检测确认并打款。</div>
        </CollapseItem>
        <CollapseItem name="2-5">
          <p slot="title">Q5: 留了支付宝账号，订单已经好多天都是待付款，为什么一直没支付？</p>
          <div>A5: 您核实下您的支付宝账号是否正确，提供的姓名是否经过实名认证，如果不一致的话请尽快来电告知下正确的支付宝账号和姓名，我们会优先帮您付款。</div>
        </CollapseItem>
      </Collapse>

      <Collapse class="view" accordion v-show="activeIndex==3">
        <CollapseItem name="3-1">
          <p slot="title">Q1: 回收宝如何质检？</p>
          <div>A1: 首先了解是否是真机，从业多年的专业质检人员采用盲检技术仔细检查，安排付款。</div>
        </CollapseItem>
        <CollapseItem name="2-2">
          <p slot="title">Q2: 我把手机邮寄过来后，万一你们把我手机拆机了，换了零件呢？</p>
          <div>A2: 请您放心我们不做任何拆机行为。如果有拆机行为，您的手机维修标签会有损毁。</div>
        </CollapseItem>
      </Collapse>

      <Collapse class="view" accordion v-show="activeIndex==4">
        <CollapseItem name="4-1">
          <p slot="title">Q1: 会不会泄露我的数据和隐私呢？</p>
          <div>A1:建议您将手机的锁屏密码及账号解除，并恢复出厂设置。此外，回收宝会使用专业的数据清除和覆盖技术，保证您的数据安全</div>
        </CollapseItem>
        <CollapseItem name="4-2">
          <p slot="title">Q2: 我不记得我icloud密码了，怎么办？回不回收？</p>
          <div>A2: 您可以联系您手机售后客服帮助找回您的密码，对于icloud无法解除的机子，回收宝不予回收；若收到此类机子，将退回，您需承担双向运费</div>
        </CollapseItem>
      </Collapse>

      <Collapse class="view" accordion v-show="activeIndex==5">
        <CollapseItem name="5-1">
          <p slot="title">Q1: 什么情况手机会被退回？</p>
          如果您的手机有如下情况，回收宝会进行退回处理：<br/>
          1.山寨机、高仿机，这种情况回收宝不承担运费。<br/>
          2.在客服与您沟通后未达成成交需退回时，这种情况回收宝承担退货运费。<br/>
          3.无理由要求退回，这种情况回收宝不承担运费。<br/>
          4.屏幕锁和云账号锁未解锁手机，这种情况回收宝不承担运费。
        </CollapseItem>
      </Collapse>
      <!-- <a class="ntkf-button" href="javascript:void(0);" v-ntalk="'kf_9336_1467619621802'" data-ntalk-params="ntalkParams">
        <span>找不到我的问题，联系在线客服</span>
        <img v-lazy="'//s1.huishoubao.com/static/pc/1001/img/logo-headset-big.png'">
      </a> -->
      <a class="ntkf-button" href="javascript:void(0);" @click="qiyukf">
        <span>找不到我的问题，联系在线客服</span>
        <img v-lazy="'//s1.huishoubao.com/static/pc/1001/img/logo-headset-big.png'">
      </a>
    </div>
  </div>
</template>
<script>
import { Collapse, CollapseItem } from 'element-ui';
import Backdrop from '@/components/backdrop';
import openDirective from '@/helper/ntalker';

let uuid = '';
if (typeof window !== 'undefined') {
  uuid = window.localStorage.getItem('HSB_UUID');
}

export default {
  components: {
    Collapse,
    CollapseItem,
    Backdrop
  },
  props: {
    value: Boolean
  },
  directives: {
    ntalk: openDirective
  },
  data () {
    return {
      activeIndex: 0,
      menu: [{
        text: '回收流程'
      }, {
        text: '邮寄'
      }, {
        text: '钱款'
      }, {
        text: '质检'
      }, {
        text: '安全隐私'
      }, {
        text: '售后'
      }],
      ntalkParams: {
        // 企业ID，为固定值，必填
        siteid: 'kf_9336',
        // 接待组ID，为固定值，必填
        settingid: 'kf_9336_1467619621802',
        uid: uuid || '',
        uname: '',
        isvip: '0'
      }
    };
  },
  methods: {
    qiyukf () {
      window.open('https://webchat-bj.clink.cn/chat.html?accessId=9b2af095-b970-4b55-8455-53eb4b91d1c9&language=zh_CN', '_blank', 'scrollbars=yes,resizable=1,location=false,menubar=false,modal=false,alwaysRaised=yes,width=720,height=720');
    }
  }
};
</script>

<style scoped>
.service-popup {
  width: 760px;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-top: -235px;
  margin-left: -380px;
  background: #ffffff;
  font-size: 14px;
  color: #333333;
}

.tab-item {
  float: left;
  width: 16.666%;
  height: 80px;
  text-align: center;
  cursor: pointer;
  padding-top: 50px;
  background-repeat: no-repeat;
  background-color: #f8f9fa;
  background-position: center 13px;
  cursor: pointer;
  &:nth-child(1) {
    background-image: url(https://www.huishoubao.com/static/pc/1001/img/logo-process.png);
  }
  &:nth-child(2) {
    background-image: url(https://www.huishoubao.com/static/pc/1001/img/logo-car.png);
  }
  &:nth-child(3) {
    background-image: url(https://www.huishoubao.com/static/pc/1001/img/logo-money.png);
  }
  &:nth-child(4) {
    background-image: url(https://www.huishoubao.com/static/pc/1001/img/logo-testing.png);
  }
  &:nth-child(5) {
    background-image: url(https://www.huishoubao.com/static/pc/1001/img/logo-privacy.png);
  }
  &:nth-child(6) {
    background-image: url(https://www.huishoubao.com/static/pc/1001/img/logo-return.png);
  }
}

.tab-item--active {
  padding-top: 46px;
  color: #fabe00;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center 9px;
  border-top: 4px solid #fabe00;
  &:nth-child(1) {
    background-image: url(https://www.huishoubao.com/static/pc/1001/img/logo-process-y.png);
  }
  &:nth-child(2) {
    background-image: url(https://www.huishoubao.com/static/pc/1001/img/logo-car-y.png);
  }
  &:nth-child(3) {
    background-image: url(https://www.huishoubao.com/static/pc/1001/img/logo-money-y.png);
  }
  &:nth-child(4) {
    background-image: url(https://www.huishoubao.com/static/pc/1001/img/logo-testing-y.png);
  }
  &:nth-child(5) {
    background-image: url(https://www.huishoubao.com/static/pc/1001/img/logo-privacy-y.png);
  }
  &:nth-child(6) {
    background-image: url(https://www.huishoubao.com/static/pc/1001/img/logo-return-y.png);
  }
}

.view {
  height: 329px;
  overflow-y: scroll;
  padding: 0 35px;
  img {
    max-width: 100%;
  }
}

.icon-close {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  right: -40px;
  top: -40px;
  background: url(https://www.huishoubao.com/static/pc/1001/img/logo-delete.png) no-repeat center;
  transition: all 1s;
  cursor: pointer;
  &:hover {
    transform: rotateZ(360deg);
  }
}

.ntkf-button {
  display: block;
  height: 56px;
  line-height: 56px;
  width: 100%;
  background: #fabe00;
  color: #ffffff;
  font-size: 16px;
  text-align: center;
  img {
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/components/service-popup/index.vue